/*
 * @Author: dengxy 1148926496@qq.com
 * @Date: 2024-12-20 11:08:12
 * @LastEditors: dengxy 1148926496@qq.com
 * @LastEditTime: 2025-09-09 09:27:58
 * @FilePath: \frontend\src\store\modules\dict.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getDict as getDictData } from '@/api/upms'
import dictTool from "@/utils/dict";
const useDictStore = defineStore(
  'dict',
  {
    state: () => ({
      dict: new Array()
    }),
    actions: {
      // 获取字典
      getDict(_key) {
        if (_key == null && _key == "") {
          return null;
        }
        try {
          for (let i = 0; i < this.dict.length; i++) {
            if (this.dict[i].key == _key) {
              return this.dict[i].value;
            }
          }
        } catch (e) {
          return null;
        }
      },
      // 设置字典
      setDict(_key, value) {
        console.log('设置字典_key==',_key,value)
        if (_key !== null && _key !== "") {
          this.dict.push({
            key: _key,
            value: value
          });
        }
      },
      // 删除字典
      removeDict(_key) {
        var bln = false;
        try {
          for (let i = 0; i < this.dict.length; i++) {
            if (this.dict[i].key == _key) {
              this.dict.splice(i, 1);
              return true;
            }
          }
        } catch (e) {
          bln = false;
        }
        return bln;
      },
      // 清空字典
      cleanDict() {
        this.dict = new Array();
      },
      // 初始字典
      initDict() {
        return new Promise(resolve => {
          getDictData().then(res => {
            const dicts = res.data || []
            for (let key in dicts) {
              let dict = JSON.parse(dicts[key])
              console.log('dictdict=',key,dict)
              dict = dict.map(item => {
                return {
                  ...item,
                  label: item.label || item.name
                }
              })
              this.setDict(key, dict)
            }
            for (let key in dictTool.data) {
              const dict = dictTool.data[key]
              this.setDict(key, dict)
            }
            resolve()
          })
        })
      }
    }
  })

export default useDictStore
